<template>
  <div class="common-width common-items-center common-space-between common-pading indexTop" :style ='{height:this.$store.state.topBlockHeight+"px"}'>
        <div class="common-items-center">
            <div class="title">百仁吉运维管理系统</div>  
        </div>
        <div class="common-items-center">
            <SwitchTab></SwitchTab>
            <div class="warp-screen" @click="screenBtn">
                <img class="screen"  src="@/assets/custom-icon/screen.svg"/>
            </div>
            <div class="header-block">
                <img class="header" src="@/assets/custom-icon/header.png"/>
            </div>
            <el-popover  placement="bottom-end" width="346" popper-class="popperClass" offset="100"	 trigger="click">
                <div class="block">
                        <div class="common-space-around img">
                            <img class="headerImg" src="@/assets/custom-icon/header.png"/>
                        </div>
                        <div class="nickname">{{nickName}}</div>
                        <div class="warpList">
                            <div class="common-space-between list">
                                <div class="left listMark">手机号</div>
                                <div class="right listMark">{{mobile}}</div>
                            </div>
                            <div class="common-space-between list">
                                <div class="left listMark">所属部门</div>
                                <div class="right listMark">{{departName}}</div>
                            </div>
                            <div class="common-space-between list">
                                <div class="left listMark">所属角色</div>
                                <div class="right listMark">{{roles}}</div>
                            </div>
                            <div class="common-space-between list">
                                <div class="left listMark">近期登录</div>
                                <div class="right listMark">{{loginTime}}</div>
                            </div>
                        </div>
                        <div class="eidthBlock">
                            <!-- <div class="common-space-between list">
                                <div class="left listMark">资料修改</div>
                                <div class="right listMark"><i class="el-icon-arrow-right"></i></div>
                            </div> -->
                            <div class="common-space-between list" @click="updataPBtn">
                                <div class="left listMark">密码修改</div>
                                <div class="right listMark"><i class="el-icon-arrow-right"></i></div>
                            </div>
                            <div class="common-space-between list" @click="logOut">
                                <div class="left listMark">安全退出</div>
                                <div class="right listMark"><i class="el-icon-arrow-right"></i></div>
                            </div>
                        </div>
                </div>
                <span slot="reference" class="el-dropdown-link">
                    <span class="name">{{name}}</span>
                </span>
            </el-popover>
           
        </div>
        <UpdataPw ref="upDatePw"></UpdataPw>
    </div>
</template>
<script>
    import {getDateTime} from '@/utils/util'
    import { url,operate,loginApi } from '@/utils/config'
    import { getFun,postFun} from '@/utils/httpFun'
    import UpdataPw from './block-pword.vue'
    import SwitchTab from './block-switchTab.vue'
    export default{
        components:{
          UpdataPw:UpdataPw,
          SwitchTab:SwitchTab
        },
        data(){
           return{
               isFullFlag:false,
               indexNo:0,
               dataTime:"",
               name:"",
               nickName:"",
               mobile:"",
               departName:"",
               roles:"",
               loginTime:"",
            }
        },
        created(){
            setInterval(res=>{
              this.dataTime = getDateTime()
            },1000)
            this.getMess()
        },
        mounted(){
        },
        methods:{
            //获取个人信息
            async getMess(){
               let parms = {
                   loginType:1
               } 
               await getFun(operate.PERSONALMESS,parms,res=>{
                    let dataMess = res.data
                    this.name=dataMess.operateUserVo.name
                    this.nickName=dataMess.operateUserVo.name,
                    this.mobile=dataMess.operateUserVo.mobile
                    this.departName=dataMess.operateUserVo.departName
                    this.roles=dataMess.operateUserVo.roles[0].name
                    this.loginTime=dataMess.loginTime
                    localStorage.setItem("BrenPlivateMessage",JSON.stringify(dataMess))
               })
            },

            //修改密码
            updataPBtn(){
                this.$refs.upDatePw.showBlockM()
            },

            //安全退出
            logOut(){

                this.$confirm('确认要退出登录吗?', '确认退出', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    customClass:"logoutPop",
                }).then(() => {
                    let parms = {
                            platform:1,
                            model:1
                        }
                    postFun(loginApi.OUTLOGIN,parms,res=>{
                         if(res.code==1 && res.data){
                            localStorage.removeItem("YunWeiTikenBRJ")
                            localStorage.removeItem("BrenPlivateMessage")
                            localStorage.removeItem("menuBtnVav")
                            this.$router.replace({
                                path:"/",
                                query:{}
                            })
                         }
                    })
                }).catch(() => {
         
                });  
            },

           
            //全屏及其退出全屏
            screenBtn(){
                this.isFullFlag =!this.isFullFlag
                const element = document.getElementById('content');//指定全屏区域元素
                if(this.isFullFlag){
                    element.requestFullscreen()
                }else{
                    document.exitFullscreen();
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .indexTop{
        background: #458EFF;
        // background: black;
        box-shadow: 0 0 14px 0 rgba(177,177,177,0.50);
        user-select:none; /* CSS3属性 */
    }
    .btn{
        margin-right: 10px;
    }
    .title{
      
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #FFFFFF;
        letter-spacing: 0;
       
    }
    .dataTime{
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #FFFFFF;
        padding-left:10px;
        position: relative;
        margin-right: 10px;
    }
    .warp-screen{
        margin-right: 32px;
        width: 36px;
        height: 36px;
        background: rgba(255,255,255,0.30);
        box-shadow: 2px 2px 8px 0px rgba(40,102,198,0.32);
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        justify-content: space-around;
        align-items: center;
    }
    .screen{
        width: 20px;
        height: 20px;
    }
    .header-block{
        height:38px;
        width: 38px;
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 2px 2px 8px 0px rgba(40,102,198,0.32);
        margin-right:12px;
    }
    .header{
        height: 50px;
        width: 50px;
        border-radius: 50%;
        cursor: pointer;
        position: relative;
        top: -6px;
        left: -6px;
    }
    .full{
        height: 20px;
        width: 20px;
        margin-right: 10px;
        cursor: pointer;
    }
    .el-icon-arrow-down{
        color: #FFFFFF;
    }
    .name{
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #FFFFFF;
        letter-spacing: 0;
        cursor: pointer;
    }

    //个人信息
    .block{
       .img{
         padding-top: 30px;
       }
       .headerImg{
        width: 96px;
        height: 96px;
       }
       .list{
         padding: 0 20px;
         box-sizing: border-box;
       }

       .nickname{
            font-family: PingFangSC-Semibold;
            font-size: 18px;
            color: #4D5C72;
            letter-spacing: 0;
            line-height: 16px;
            font-weight: 600;
            text-align: center;
            padding-top: 20px;
            padding-bottom: 27px;
            border-bottom:1px solid rgba(202,202,202,0.22);
       }
       .warpList{
          padding-top: 27px;
          padding-bottom: 7px;
        .listMark{
            opacity: 0.7;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #4D5C72;
            letter-spacing: 0;
            font-weight: 400;
            padding-bottom: 20px;
        }
       }
       .eidthBlock{
            border-top: 1px solid rgba(202,202,202,0.22);
            padding-top: 27px;
            cursor: pointer;
            .listMark{
                opacity: 0.7;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #4D5C72;
                letter-spacing: 0;
                font-weight: 400;
                padding-bottom: 20px;
            }
       }
    }
    .logOut{
        margin-left: 10px;
    }
    .logoutPop{
        width: 260px!important;
    }
   
</style>